import { getData } from 'api/requests/GET_TRADE_SHOWS';

import { getQueryKey } from 'helpers/getQueryKey';

export const getShowDataOptions = () => {
  return {
    queryKey: getQueryKey('TRADE_SHOWS'),
    queryFn: () => {
      return getData();
    },
  };
};
